import { useState } from "react";
import "./ForgotPassword.css";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { publicRequest } from "../../RequestMethods";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await publicRequest.post("password-reset/request", { email });
      // Backend always returns the same generic message whether or not the
      // email exists, to avoid leaking which accounts are registered.
      setSubmitted(true);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Une erreur est survenue.", {
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h1 className="login-title">Mot de passe oublié</h1>

      <div className="signup-container">
        {submitted ? (
          <p className="forgot-password-confirmation">
            Si un compte existe avec cet e-mail, un lien de réinitialisation vient d'être envoyé.
            Vérifiez votre boîte de réception (valable 1 heure).
          </p>
        ) : (
          <form className="signup-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Envoi..." : "Envoyer le lien de réinitialisation"}
            </button>
          </form>
        )}

        <p>
          <Link to="/login">Retour à la connexion</Link>
        </p>
      </div>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default ForgotPassword;
